import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { ConfirmationCustomComponent }    from './confirmation.custom.component';
import { ConfirmationGenericComponent }   from './confirmation.generic.component';
import { ConfirmationHardComponent }      from './confirmation.hard.component';
import { ConfirmationNotifyComponent }    from './confirmation.notify.component';
import { ConfirmationQuestionComponent }  from './confirmation.question.component';
import { ConfirmationRememberComponent }  from './confirmation.remember.component';
import { ConfirmationSaveComponent }      from './confirmation.save.component';
import { ConfirmationSubscribeComponent } from './confirmation.subscribe.component';
import { ConfirmationTextComponent }      from './confirmation.text.component';
import { ConfirmService }                 from './confirm.service';
import { SharedModule }                   from '../../shared/shared.module';

@NgModule({
  declarations: [
    ConfirmationCustomComponent,
    ConfirmationGenericComponent,
    ConfirmationHardComponent,
    ConfirmationNotifyComponent,
    ConfirmationQuestionComponent,
    ConfirmationRememberComponent,
    ConfirmationSaveComponent,
    ConfirmationSubscribeComponent,
    ConfirmationTextComponent
  ],
  entryComponents: [
    ConfirmationCustomComponent,
    ConfirmationGenericComponent,
    ConfirmationHardComponent,
    ConfirmationNotifyComponent,
    ConfirmationQuestionComponent,
    ConfirmationRememberComponent,
    ConfirmationSaveComponent,
    ConfirmationSubscribeComponent,
    ConfirmationTextComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    ConfirmService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ConfirmModule {}
